module.exports = __webpack_public_path__ + "static/media/Vivo-how-does-it-work.0a84c6bd.jpg";